import {DecimalPipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {BcbChartYear, BcbPolicyDecision, BcbSeries, BcbSeriesKey} from './bcb.models';

const LEFT = 44;
const WIDTH = 1112;

@Component({
  selector: 'app-bcb-chart',
  standalone: true,
  imports: [DecimalPipe],
  templateUrl: './bcb-chart.component.html',
  styleUrl: './bcb-chart.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BcbChartComponent {
  @Input({required: true}) row!: BcbChartYear;
  @Input({required: true}) visibleKeys!: ReadonlySet<BcbSeriesKey>;
  readonly months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  get visibleSeries(): BcbSeries[] {
    return this.row.series.filter((series) => this.visibleKeys.has(series.key));
  }

  x(date: string): number {
    const start = Date.UTC(this.row.year, 0, 1);
    const end = Date.UTC(this.row.year + 1, 0, 1);
    return LEFT + (Date.parse(`${date}T00:00:00Z`) - start) / (end - start) * WIDTH;
  }

  y(score: number): number {
    return 188 - ((score - 1) / 9) * 156;
  }

  points(series: BcbSeries): string {
    return series.weeks
      .filter((week) => week.score !== null && Number.isFinite(week.score))
      .map((week) => `${this.x(week.lastObservation)},${this.y(week.score as number)}`)
      .join(' ');
  }

  monthX(index: number): number {
    return LEFT + ((index + .5) / 12) * WIDTH;
  }

  decisionLabel(decision: BcbPolicyDecision): string {
    if (decision.changePoints === null) return 'initial observation';
    if (decision.changePoints === 0) return 'hold';
    return `${decision.changePoints > 0 ? 'hike' : 'cut'} ${Math.abs(decision.changePoints)}%`;
  }
}
